import { Component, output, input, signal, effect } from '@angular/core';
import { ModelElevationTabComponent } from '../model-elevation-tab/model-elevation-tab.component';
import { OptionsTabComponent } from '../options-tab/options-tab.component';
import { TabsModule } from '@openng/optimus-ui/tabs';
import { SpecLot } from '../../../models/build-spec-models.models';

@Component({
  selector: 'app-build-spec-models-details',
  imports: [ModelElevationTabComponent, OptionsTabComponent, TabsModule],
  templateUrl: './build-spec-models-details.component.html'
})
export class BuildSpecModelsDetailsComponent {
  readonly specLot = input.required<SpecLot>();
  readonly close = output<void>();
  readonly activeTabIndex = signal<number>(0);
  readonly selectedModelId = signal<string | null>(null);
  readonly selectedElevationId = signal<string | null>(null);

  constructor() {
    effect(() => {
      const lot = this.specLot();
      if (lot?.selectedElevation?.id && !this.selectedElevationId()) {
        this.selectedElevationId.set(lot.selectedElevation.id);
      }
    });

    effect(() => {
      const lot = this.specLot();
      if (lot?.selectedModel?.id && !this.selectedModelId()) {
        this.selectedModelId.set(lot.selectedModel.id);
      }
    });
  }

  onClose(): void {
    this.close.emit();
  }

  onTabChange(index: number | string | undefined): void {
    const tabIndex = typeof index === 'string' ? parseInt(index, 10) : index;
    this.activeTabIndex.set(tabIndex!);
  }

  onModelSelected(modelId: string | null): void {
    this.selectedModelId.set(modelId);
  }

  onElevationSelected(elevationId: string | null): void {
    this.selectedElevationId.set(elevationId);
  }
}
